import { render } from "./AddConnectionModal.vue?vue&type=template&id=0b351d62&ts=true"
import script from "./AddConnectionModal.vue?vue&type=script&lang=ts"
export * from "./AddConnectionModal.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-distribution-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__